import React from 'react';
import { Skeleton } from '@mui/material';
export var renderSlides = function (_a) {
    var lazy = _a.lazy, loaded = _a.loaded, slides = _a.slides;
    return (React.createElement(React.Fragment, null, !!slides.length &&
        slides.map(function (slide, i) {
            var isSlideLoaded = loaded[i];
            var slideContent = slide;
            if (lazy && !isSlideLoaded) {
                slideContent = (React.createElement(Skeleton, { variant: "rectangular", width: '100%', height: '100%' }));
            }
            return (React.createElement("div", { key: i, className: "keen-slider__slide slide-".concat(i), style: { cursor: 'grab' } }, slideContent));
        })));
};
//# sourceMappingURL=utils.js.map